module.exports = __webpack_public_path__ + "img/1-6.1c2270eb.jpg";